import React from "react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";

export default function SideMenu({ setListIsOpen }) {
  // EXIT ANIMATION DOES NOT RUN
  return (
    <motion.div
      initial={{ x: "100%" }}
      animate={{ x: 0, transition: { duration: 0.8 } }}
      exit={{ x: "100%" }}
      className="fixed top-16 backdrop-blur-3xl w-full  flex flex-col px-5 text-xl"
      onClick={() => {
        setTimeout(() => {
          setListIsOpen(false);
        }, 50); // این تأخیر کوتاه به AnimatePresence فرصت exit میده
      }}
    >
      <NavLink
        to={"./products/all"}
        // onClick={() => window.scrollTo(0, 0)}
        title="محصولات آزمایاران"
        className="h-full w-full flex-col justify-center border-b px-2 py-3 duration-300 ease-in-out hover:rounded-t-sm hover:bg-custom-green-300 hover:bg-opacity-20 hover:font-semibold"
      >
        محصولات{" "}
      </NavLink>

      <NavLink
        to={"./about_us"}
        // onClick={() => window.scrollTo(0, 0)}
        title="درباره آزمایاران"
        className="h-full w-full flex-col justify-center border-b px-2 py-3 duration-300 ease-in-out hover:rounded-t-sm hover:bg-custom-green-300 hover:bg-opacity-20 hover:font-semibold"
      >
        درباره ما
      </NavLink>

      <NavLink
        to={"./contact_us"}
        // onClick={() => window.scrollTo(0, 0)}
        title="تماس با آزمایاران"
        className="h-full w-full  flex-col justify-center border-b px-2 py-3 duration-300 ease-in-out hover:rounded-t-sm hover:bg-custom-green-300 hover:bg-opacity-20 hover:font-semibold"
      >
        تماس با ما
      </NavLink>

      <a
        href="https://blog.azmayaran.com/"
        target="_blank"
        // onClick={() => window.scrollTo(0, 0)}
        title="وبلاگ آزمایاران"
        className="flex h-full w-full flex-col justify-center border-b px-2 py-3 duration-300 ease-in-out hover:rounded-t-sm hover:bg-custom-green-300 hover:bg-opacity-20 hover:font-semibold"
      >
        وبلاگ
      </a>
    </motion.div>
  );
}
